/** Müşterinin doğrulanmış iletişim izni var mı */
export const musteriIletisimIzniVerildi = (musteri) => musteri?.iletisimIzni?.verildi === true;

/** API müşteri nesnesinden iletişim izni alanını normalize et */
export const normalizeIletisimIzni = (izin) => {
  if (!izin || izin.verildi !== true) {
    return { verildi: false };
  }
  return izin;
};
